
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { breakTitle } from "../../Custom/Custom";

const excelColumnDesign = (excelObject, bold, size, horizontal) => {

  excelObject.getCell(1).font = { bold: bold, name: 'SansSerif', size: size };
  excelObject.getCell(1).alignment = { horizontal: horizontal, vertical: 'middle', wrapText: true };
  excelObject.height = 25;
  excelObject.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  return excelObject;
}


const eachCellExcelColumnDesign = (excelObject, worksheet, bold, size, horizontal, columnWidth) => {

  excelObject.eachCell((cell, colNumber) => {
    cell.font = { bold: bold, name: 'SansSerif', size: size };
    cell.alignment = { horizontal: horizontal, vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = columnWidth;
  });
  return excelObject;
}

const getExcelTwoHeader = (worksheet, excelObjectData, first_horizontal, second_horizontal) => {
  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif' };
  firstHeaderRow.getCell(1).alignment = { horizontal: first_horizontal, vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;


  //Second Row Design and  Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(2).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(2).font = { bold: true, name: 'SansSerif', size: 14 };
  secondHeaderRow.getCell(2).alignment = { horizontal: second_horizontal, vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 25;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  return worksheet;

}

export const generateExcel = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 40;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    if (excelObjectData.redGroup.includes(cell.model.value)) {
      cell.font.color = { argb: 'FF0000' };
    }
    const column = worksheet.getColumn(colNumber);
    column.width = 22;

  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




// Wages Rates Report ***************
export const generateWagesRateExcel = async (excelObjectData) => {


  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //Second Row Design and  Merge cells A2:K2

  const headerRow3 = worksheet.addRow(excelObjectData.headerFirstColumn);
  headerRow3.height = 30;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;
  });

  if (excelObjectData.reportType === 'barber' ||
    excelObjectData.reportType === 'rmason' ||
    excelObjectData.reportType === 'uskill' ||
    excelObjectData.reportType === 'avgrmasonunskill'
  ) {
    worksheet.mergeCells('A3:C3')
    worksheet.mergeCells('H3:J3')
  } else if (excelObjectData.reportType === 'tailor') {
    worksheet.mergeCells('A3:C3')
  } else if (excelObjectData.reportType === 'agri') {
    worksheet.mergeCells('A3:C3')
  }


  //excel English Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow4.height = 45;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;

  });

  //excel English Column
  if (excelObjectData.reportType === 'barber' ||
    excelObjectData.reportType === 'tailor' ||
    excelObjectData.reportType === 'rmason' ||
    excelObjectData.reportType === 'uskill' ||
    excelObjectData.reportType === 'avgrmasonunskill'
  ) {
    let year = parseInt(excelObjectData.year);
    const headerRow5 = worksheet.addRow([``, ``, `${year}`, `${year}`, `${year}`,
      `${year}`, `${year}`, `${year}`, `${year + 1}`, `${year + 1}`, `${year + 1}`, `${year + 1}`,
      `${year + 1}`, `${year + 1}`, `${year} - ${year + 1}`, ``]);

    headerRow5.height = 45;
    headerRow5.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 14;
    });
  }




  const headerRow6 = worksheet.addRow(excelObjectData.number);
  headerRow6.height = 30;
  headerRow6.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;
  });



  const headerRow7 = worksheet.addRow(excelObjectData.headerStateColumn);
  headerRow7.height = 30;
  headerRow7.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;
  });



  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);

}


// Bull Report ***************
export const generateBullReportExcel = async (excelObjectData) => {


  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'left', 'left')
  let rowText = excelObjectData.thirdRowText;
  const headerRow5 = worksheet.addRow([`${rowText[0]},`, ``, ``, ``, ``, ``, ``, `${rowText[1]}`, ``, ``, ``, ``, ``, ``,
  `${rowText[2]},`, ``, ``, ``, ``, ``, ``, `${rowText[3]}`, ``, ``, ``, ``, ``, ``]);

  headerRow5.height = 45;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    if ([1, 15].includes(colNumber)) {
      cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
    } else if ([8, 22].includes(colNumber)) {
      cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
    } else {
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

  });

  worksheet.mergeCells("A3:G3");
  worksheet.mergeCells("H3:N3");
  worksheet.mergeCells("O3:U3");
  worksheet.mergeCells("V3:AB3");

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 45;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;

  });




  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      if (index === 0) {
        cell.font = { name: 'SansSerif', size: 10, bold: true };
      } else {
        cell.font = { name: 'SansSerif', size: 10 };
      }

      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };

    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);

}



//get District Price Report for Rural Consumer Retail Price
export const districtPriceReprt = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'left', 'left')

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 45;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 14;

  });

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      if ([0, 1, 2].includes(index)) {
        cell.font = { name: 'SansSerif', size: 10, bold: true };
      } else {
        cell.font = { name: 'SansSerif', size: 10 };
      }

      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'medium' },
        right: { style: 'thin' },
      };

    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}




//get Urban West, Rural West,Urban East, Urban State, Rural State Index Report *********************
export const getGroupSubGroupExcleReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')


  //Second Row Design and  Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(5).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(5).font = { bold: true, name: 'SansSerif', size: 14 };
  thirdHeaderRow.getCell(5).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 25;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };




  //excel English Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow4.height = 45;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 30;

  });
  if (excelObjectData.report === '2') {
    worksheet.mergeCells('C4:E4')
  }



  const headerRow5 = worksheet.addRow(excelObjectData.headerYearColumns);
  headerRow5.height = 45;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 30;

  });


  worksheet.mergeCells('A4:A5')
  worksheet.mergeCells('B4:B5')
  if (excelObjectData.report === '1') {// Monthly
    worksheet.mergeCells('D4:D5')
    worksheet.mergeCells('E4:E5')
  }
  if (excelObjectData.report === '2') {// Quarterly
    worksheet.mergeCells('F4:F5')
    worksheet.mergeCells('G4:G5')
  }

  let arrayNumber = [];
  if (excelObjectData.report === '1') {
    arrayNumber = [1, 2, 3, 4, 5]
  }
  if (excelObjectData.report === '2') {
    arrayNumber = [1, 2, 3, 4, 5, 6, 7]
  }

  const headerRow6 = worksheet.addRow(arrayNumber);
  headerRow6.height = 27;
  headerRow6.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 30;

  });



  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    let applyRedColor = false;
    const redGroup = excelObjectData.redGroup;

    row.map((value) => {
      if (redGroup.includes(value)) {
        applyRedColor = true;
      }

      return value; // Return the value to maintain array structure
    });



    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {

      const cell = dataRow.getCell(index + 1);

      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (applyRedColor) {
        cell.font.color = { argb: 'FF0000' }; // Red color
      }

    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}




//Whole Sale Raw Wool Report *********************
export const getWholeSaleRawWoolReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')


  if (excelObjectData.reportType === 'districtWise') {

    const headerRow3 = worksheet.addRow(excelObjectData.thirdRowText);
    headerRow3.height = 27;
    headerRow3.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;

    });
    worksheet.mergeCells('A3:B3')
    worksheet.mergeCells('G3:H3')



    const headerRow4 = worksheet.addRow(excelObjectData.fourthRowText);
    headerRow4.height = 27;
    headerRow4.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;

    });
    worksheet.mergeCells('C4:G4')


    const headerRow5 = worksheet.addRow(excelObjectData.fifthRowText);
    headerRow5.height = 27;
    headerRow5.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;

    });
    worksheet.mergeCells('A4:A5')
    worksheet.mergeCells('B4:B5')
    worksheet.mergeCells('H4:H5')




  }




  if (excelObjectData.reportType === 'monthly') {

    //excel English Column
    const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
    headerRow4.height = 45;
    headerRow4.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      //  cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;

    });


    const headerRow6 = worksheet.addRow(excelObjectData.headerNumberColumns);
    headerRow6.height = 27;
    headerRow6.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;

    });
  }





  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {

      const cell = dataRow.getCell(index + 1);

      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };


    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}




//Monthly Whole Sale Price Itemwise Report *********************
export const getMonthlyWholeSaleReportData = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')


  //excel English Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow4.height = 45;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;
    if (![0, 1, 2, 3, 5, 6, 7, 8].includes(colNumber)) {

      headerRow4.getCell(colNumber).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f7b602' }
      };
    }


  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {

      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (index === 8) {

        dataRow.getCell(8).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '369c4b' }
        };
      }


    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}




export const generateAnimalProductInputReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:U1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Second Row Design and  Merge cells A2:U2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 30;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow1 = worksheet.addRow([
    'जनपद ', '', `भाव दिनांक :- (${excelObjectData.fromDate} - ${excelObjectData.toDate})`, '', '', '', ''
  ]);
  headerRow1.height = 20;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

  });

  worksheet.mergeCells('A3:B3');
  worksheet.mergeCells('C3:G3');

  // Create the second row of headers (individual columns under year ranges)
  const headerRow2 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow2.height = 55;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;

  });




  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });
  });


  const lastRow = worksheet.addRow(['', '', '', '', '', '', '']); // Add a row with empty cells
  lastRow.height = 20;  // Adjust height if necessary

  // Merge cells A to G in the last row
  worksheet.mergeCells(lastRow.number, 1, lastRow.number, 7); // Merge cells from column 1 (A) to column 7 (G)

  // Set the value and style for the merged cell
  const mergedCell = lastRow.getCell(1); // Use the first cell in the merged range
  mergedCell.value = 'कार्यलय अर्थ एवं संख्याधिकारी';
  mergedCell.font = { name: 'SansSerif', size: 12, bold: true };
  mergedCell.alignment = { horizontal: 'center', vertical: 'middle' };
  mergedCell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },

  };
  worksheet.columns.forEach((column) => {
    column.width = 15;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//Percentage variation Sheet of Urban Wage Index, 
//Percentage Variation Sheet of Rural Wage Index Report
export const perVariationRuralAndUrbanwageIndex = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')
  //third Row Design and  Merge cells A2:M2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 15 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 55;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 16;

  });




  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if ([0, 1].includes(index)) {
        cell.font.bold = true
      }
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//Major WPI Report  Report *********************
export const getMajorWPIReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')


  //First Row Design and Merge cells A1:U1
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const firstHeaderRow = worksheet.getRow(3);
  firstHeaderRow.getCell(1).value = excelObjectData.thirdRowText
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14, bold: true, };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //excel English Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow4.height = 45;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 30;

  });
  //excel English Column
  const headerRow5 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow5.height = 45;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

    const column = worksheet.getColumn(colNumber);
    column.width = 30;

  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (index === 0) {
        cell.font.bold = { bold: true };
      }
    });


  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}



//************Urban Regional General Index  Report *********************
export const getUrbanRegionalGeneralIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  // secondHeaderRow.getCell(2).value = excelObjectData.secondRowText;
  // secondHeaderRow.getCell(2).font = {  bold: true,name: 'SansSerif',size:14};
  // secondHeaderRow.getCell(2).alignment = { horizontal: second_horizontal,vertical: 'middle',wrapText: true};
  // secondHeaderRow.height = 25;

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14, bold: true, };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14, bold: true, };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 30;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  const fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText
  fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 14, bold: true, };
  fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fifthHeaderRow.height = 30;
  fifthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  const headerRow4 = worksheet.addRow(excelObjectData.FirstHeaderHindiColumns);
  headerRow4.height = 45;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

  });

  if (excelObjectData.groupType === "All") { ////Region Wise
    worksheet.mergeCells("C6:F6")
  }




  const headerRow5 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow5.height = 45;
  headerRow5.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 22;

  });


  if (excelObjectData.groupType === "All") { ////Region Wise

    worksheet.mergeCells("A6:A7")
    worksheet.mergeCells("B6:B7")
    worksheet.mergeCells("G6:G7")

    const headerRow6 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow6.height = 45;
    headerRow6.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
    });

  }

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

    });


  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}



//*******Rural Wage Region Index ****************
export const ruralWageRegionIndex = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  // worksheet= getExcelTwoHeader(worksheet,excelObjectData,'right','center')
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //Second Row Design and  Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
  thirdHeaderRow.getCell(1).alignment = { horizontal: "center", vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 25;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  const headerRow1 = worksheet.addRow(excelObjectData.headerColumn);



  headerRow1.height = 20;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;
  });

  worksheet.mergeCells('A4:B4');
  worksheet.mergeCells('F4:G4');


  //excel English Column

  // const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
  // headerRow4.height=45;
  // headerRow4.eachCell((cell,colNumber ) => {
  //   cell.font = { bold: true, name: 'SansSerif',size:12};
  //   cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  //  cell.border = {
  //     top: { style: 'thin' },
  //     left: { style: 'thin' },
  //     bottom: { style: 'thin' },
  //     right: { style: 'thin' },

  //   };
  //   const column = worksheet.getColumn(colNumber);
  //   column.width = 30;

  //   });
  // //excel English Column
  // const headerRow5 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  // headerRow5.height=45;
  // headerRow5.eachCell((cell,colNumber ) => {
  //   cell.font = { bold: true, name: 'SansSerif',size:12};
  //   cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  //   //  cell.value = breakTitle(cell.value);

  //   const column = worksheet.getColumn(colNumber);
  // column.width = 30;

  //   });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (index === 0) {
        cell.font.bold = { bold: true };
      }
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}

//********Wage Index Report************/

export const generateWagesIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);


  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 12 };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 50;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const headerRow1 = worksheet.addRow([
    '', '', 'Carpenter', '', 'Mason', '', 'Agri. Labour', ''
  ]);
  headerRow1.height = 50;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

  });


  worksheet.mergeCells('A3:B3');
  worksheet.mergeCells('C3:D3');
  worksheet.mergeCells('E3:F3');
  worksheet.mergeCells('G3:H3');


  // Create the second row of headers (individual columns under year ranges)
  const headerRow2 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow2.height = 50;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 25;

  });


  worksheet.mergeCells('A4:B4');

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 20;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
    });
  });

  worksheet.mergeCells('A5:B5');
  worksheet.mergeCells('A6:B6');
  worksheet.mergeCells('A7:B7');
  worksheet.mergeCells('A8:B8');
  worksheet.mergeCells('A9:B9');

  worksheet.mergeCells('A10:H10');


  worksheet.mergeCells('B12:C12');
  worksheet.mergeCells('B13:C13');
  worksheet.mergeCells('B14:C14');
  worksheet.mergeCells('B15:C15');
  worksheet.mergeCells('B16:C16');
  worksheet.mergeCells('B17:C17');
  worksheet.mergeCells('B18:C18');
  worksheet.mergeCells('B19:C19');
  worksheet.mergeCells('B20:C20');

  worksheet.mergeCells('A12:A14');
  worksheet.mergeCells('A15:A17');
  worksheet.mergeCells('A18:A20');


  worksheet.columns.forEach((column) => {
    column.width = 20;
  });


  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




//*******Rural Wage Region Index ****************
export const agriculturePartyIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  let thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow = excelColumnDesign(thirdHeaderRow, true, 14, 'center')

  //
  let headerRow4 = worksheet.addRow(excelObjectData.fourthRowText);
  headerRow4.height = 20;
  headerRow4 = eachCellExcelColumnDesign(headerRow4, worksheet, true, 12, 'center', 25)
  worksheet.mergeCells('A4:C4')
  worksheet.mergeCells('D4:F4')



  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  let fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  fifthHeaderRow = excelColumnDesign(fifthHeaderRow, true, 14, 'center')


  worksheet.mergeCells(excelObjectData.sixthRowMergeCells);
  let sixthHeaderRow = worksheet.getRow(6);
  sixthHeaderRow.getCell(1).value = excelObjectData.sixthRowText;
  sixthHeaderRow = excelColumnDesign(sixthHeaderRow, true, 14, 'center')



  let headerRow6 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow6.height = 45;
  headerRow6 = eachCellExcelColumnDesign(headerRow6, worksheet, true, 12, 'center', 25)


  let headerRow7 = worksheet.addRow(excelObjectData.headerYearColumns);
  headerRow7.height = 45;
  headerRow7 = eachCellExcelColumnDesign(headerRow7, worksheet, true, 12, 'center', 25)


  let headerRow8 = worksheet.addRow(excelObjectData.headerNumberColumns);
  headerRow8.height = 45;
  headerRow8 = eachCellExcelColumnDesign(headerRow8, worksheet, true, 12, 'center', 25)


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}



//******* RCPI ******
// export const generateRCPI = async (excelObjectData) => {

//   const workbook = new ExcelJS.Workbook();
//   let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
//   // worksheet= getExcelTwoHeader(worksheet,excelObjectData,'right','center')
//   worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

//   //Second Row Design and  Merge cells A2:K2
//   worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
//   const thirdHeaderRow = worksheet.getRow(3);
//   thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
//   thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
//   thirdHeaderRow.getCell(1).alignment = { horizontal: "center", vertical: 'middle', wrapText: true };
//   thirdHeaderRow.height = 25;
//   thirdHeaderRow.getCell(1).border = {
//     top: { style: 'thin' },
//     left: { style: 'thin' },
//     bottom: { style: 'thin' },
//     right: { style: 'thin' },
//   };



//   const headerRow1 = worksheet.addRow(excelObjectData.headerColumn);



//   headerRow1.height = 20;
//   headerRow1.eachCell((cell, colNumber) => {
//     cell.font = { bold: true, name: 'SansSerif', size: 10 };
//     cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
//     cell.border = {
//       top: { style: 'thin' },
//       left: { style: 'thin' },
//       bottom: { style: 'thin' },
//       right: { style: 'thin' },
//     };
//     const column = worksheet.getColumn(colNumber);
//     column.width = 25;
//   });

//   worksheet.mergeCells('A4:B4');
//   worksheet.mergeCells('F4:G4');


//   //excel English Column

//   // const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns);
//   // headerRow4.height=45;
//   // headerRow4.eachCell((cell,colNumber ) => {
//   //   cell.font = { bold: true, name: 'SansSerif',size:12};
//   //   cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
//   //  cell.border = {
//   //     top: { style: 'thin' },
//   //     left: { style: 'thin' },
//   //     bottom: { style: 'thin' },
//   //     right: { style: 'thin' },

//   //   };
//   //   const column = worksheet.getColumn(colNumber);
//   //   column.width = 30;

//   //   });
//   // //excel English Column
//   // const headerRow5 = worksheet.addRow(excelObjectData.headerEnglishColumns);
//   // headerRow5.height=45;
//   // headerRow5.eachCell((cell,colNumber ) => {
//   //   cell.font = { bold: true, name: 'SansSerif',size:12};
//   //   cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
//   //   //  cell.value = breakTitle(cell.value);

//   //   const column = worksheet.getColumn(colNumber);
//   // column.width = 30;

//   //   });


//   excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
//     const dataRow = worksheet.addRow(row);
//     dataRow.height = 27;
//     row.forEach((value, index) => {
//       const cell = dataRow.getCell(index + 1);
//       cell.font = { name: 'SansSerif', size: 10 };
//       cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
//       cell.border = {
//         top: { style: 'thin' },
//         left: { style: 'thin' },
//         bottom: { style: 'thin' },
//         right: { style: 'thin' },
//       };
//       if (index === 0) {
//         cell.font.bold = { bold: true };
//       }
//     });

//   });
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
//   const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
//   FileSaver.saveAs(blob, fileName);


// }


//urbanCurrentPriceReport data
export const urbanCurrentPriceReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'left', 'left')

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 45;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //  cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 22;

  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if ([0, 1, 2].includes(index)) {
        cell.font.bold = true;
      }
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




//*******Annual Average Of Rural & Urban Wage Index Of UP ****************
export const AnnualAverageOfRuralUrbanWageIndexOfUPReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //3
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  let thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow = excelColumnDesign(thirdHeaderRow, true, 10, 'center')
  //4
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  let fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow = excelColumnDesign(fourthHeaderRow, true, 14, 'center')

  //5
  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  let fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  fifthHeaderRow = excelColumnDesign(fifthHeaderRow, true, 10, 'center')

  //6
  worksheet.mergeCells(excelObjectData.sixthRowMergeCells);
  let sixthHeaderRow = worksheet.getRow(6);
  sixthHeaderRow.getCell(1).value = excelObjectData.sixthRowText;
  sixthHeaderRow = excelColumnDesign(sixthHeaderRow, true, 10, 'center')

  //7
  let headerRow6 = worksheet.addRow(excelObjectData.headerHindiColumns1);
  headerRow6.height = 30;
  headerRow6 = eachCellExcelColumnDesign(headerRow6, worksheet, true, 10, 'center', 25)
  worksheet.mergeCells("B7:D7")
  worksheet.mergeCells("E7:G7")

  //8
  let headerRow7 = worksheet.addRow(excelObjectData.headerHindiColumns2);
  headerRow7.height = 45;
  headerRow7 = eachCellExcelColumnDesign(headerRow7, worksheet, true, 12, 'center', 25)

  //9
  let headerRow8 = worksheet.addRow(excelObjectData.headerenglishColumns3);
  headerRow8.height = 45;
  headerRow8 = eachCellExcelColumnDesign(headerRow8, worksheet, true, 12, 'center', 25)

  //11
  worksheet.mergeCells(excelObjectData.headerYearMergeColumns);
  let headerRow10 = worksheet.getRow(10);
  headerRow10.getCell(1).value = excelObjectData.headerYearColumns;
  headerRow10 = excelColumnDesign(headerRow10, true, 10, 'center')


  //12
  let headerRow12 = worksheet.addRow(excelObjectData.headerNumberColumns);
  headerRow12.height = 30;
  headerRow12 = eachCellExcelColumnDesign(headerRow12, worksheet, true, 12, 'center', 25)



  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;

    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}



//*******Compilation ExcelReport****************
export const compilationExcelReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')
  //2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  let headerRow10 = worksheet.getRow(3);
  headerRow10.getCell(1).value = excelObjectData.thirdRowText;
  headerRow10 = excelColumnDesign(headerRow10, true, 10, 'center')


  //3
  let headerRow12 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow12.height = 30;
  headerRow12.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    if (![1, 2].includes(colNumber)) {
      headerRow12.getCell(colNumber).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd8ebed' }
      };
    }
    const column = worksheet.getColumn(colNumber);
    column.width = '27';
  });



  excelObjectData.excelRowData.forEach((row, i) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    let color=false;
    row.forEach((value, index) => {
       const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
         if(value==="Average"){
           color=true;
         }

      if ([1, 2].includes(index + 1) || color) {
        cell.style = { fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'd8ebed' } } };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      }
  
   
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

    });

  });
  // excelObjectData.excelRowData
  worksheet.mergeCells(`A5:A${excelObjectData.excelRowData.length + 4}`)
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}


//Urban district Index Report / Rural District Index

export const urbanDistrictIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')

  //excel English Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow3.height = 40;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    if (excelObjectData.redGroup.includes(cell.model.value)) {
      cell.font.color = { argb: 'FF0000' };
    }
    const column = worksheet.getColumn(colNumber);
    column.width = 22;

  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};



// Whole Sale Price Group Wise Report ***************
export const wholeSalePriceGroupWiseReport = async ({ excelObjectData, fileName }) => {

  const workbook = new ExcelJS.Workbook();

  for (let i = 0; i < excelObjectData.length; i++) {
    let worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);
    worksheet = getExcelTwoHeader(worksheet, excelObjectData[i], 'right', 'center')

    worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
    const thirdHeaderRow = worksheet.getRow(3);
    thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText
    thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
    thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    thirdHeaderRow.height = 25;
    thirdHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    //excel English Column *****************
    const headerRow4 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
    headerRow4.height = 40;
    headerRow4.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);

      if (colNumber === 2) {
        column.width = 50;
      } else {
        column.width = 20;
      }


    });


    //Excel Data Loop *****************
    excelObjectData[i].excelRowData.forEach((row) => {
      const dataRow = worksheet.addRow(row);
      let bold=false;
      dataRow.height = 20;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = { name: 'SansSerif', size: 10 };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (excelObjectData[i].headerBoldData.includes(cell.model.value)) {
            bold=true;
        }
      
        // cell.font.bold = bold || index === 2;

        if (bold) {
          cell.font.bold = true;
        }else{
            if (index === 2) {
              cell.font.bold = true;
            }else{
              cell.font.bold = false;
            }
        
        }

      });

    });



  } // End For Loop ************


  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  FileSaver.saveAs(blob, fileName);

};



//Thoke 2 excel report

export const thoke2Report = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif' };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;


  const secondHeaderRow = worksheet.addRow(excelObjectData.secondRowText);
  secondHeaderRow.height = 40;
  secondHeaderRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 14 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

  });

  worksheet.mergeCells('A2:M2')
  worksheet.mergeCells('N2:P2')
  //excel Hindi Column
  const headerRow3 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow3.height = 40;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    const column = worksheet.getColumn(colNumber);
    column.width = 15;


  });

  let headerRow4 = worksheet.addRow(excelObjectData.fourthRowText);
  headerRow4.height = 30;
  headerRow4 = eachCellExcelColumnDesign(headerRow4, worksheet, true, 12, 'center', 15)

  let headerRow5 = worksheet.addRow(excelObjectData.number);
  headerRow5.height = 30;
  headerRow5 = eachCellExcelColumnDesign(headerRow5, worksheet, false, 12, 'center', 15)

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (excelObjectData.boldcolumn.includes(value)) {
        isTotalRow = true;
      }

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
      // Customize styling for the cells if needed
    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//******* Annual Index Price Report **********

export const generateAnnualIndexReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;


  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true  };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  //Third Row Design and  Merge cells A3:L3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12,bold: true };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A3:L3

  worksheet.mergeCells(excelObjectData.fourthRowMergeCells);
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true };
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fifth Row Design and  Merge cells A3:L3

  worksheet.mergeCells(excelObjectData.fifthRowMergeCells);
  const fifthHeaderRow = worksheet.getRow(5);
  fifthHeaderRow.getCell(1).value = excelObjectData.fifthRowText;
  fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true };
  fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  fifthHeaderRow.height = 20;
  fifthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };




  const headerRow6 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow6.height = 55;
  headerRow6.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    const column = worksheet.getColumn(colNumber);
    column.width = 18;

  });

  const headerRow7 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow7.height = 55;
  headerRow7.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

  });

  const columnCount = excelObjectData.firstRowCellNumber || excelObjectData.headerEnglishColumns.length || 10;
  const headerRow8 = worksheet.addRow(
    Array.from({ length: columnCount }, (_, index) => String(index + 1))
  );
  headerRow8.height = 20;
  headerRow8.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });
 

  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 15;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

      const periodColumnIndexes = columnCount === 10 ? [0, 5] : [0];
      if (periodColumnIndexes.includes(index)) {
        cell.font = { name: 'SansSerif', size: 10, bold: true };
      }

      if (value === 'TOTAL') {
        isTotalRow = true;
      }

    });

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




//*******PercentageVariation Report Sheet****************
export const percentageVariationReportSheet = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')
  //2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  let headerRow10 = worksheet.getRow(3);
  headerRow10.getCell(1).value = excelObjectData.thirdRowText;
  headerRow10 = excelColumnDesign(headerRow10, true, 14, 'center')


  //3
  let headerRow12 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow12.height = 30;
  headerRow12.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
    // if (![1, 2].includes(colNumber)) {
    //   headerRow12.getCell(colNumber).fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: 'd8ebed' }
    //   };
    // }
    const column = worksheet.getColumn(colNumber);
    column.width = '27';
  });



  excelObjectData.excelRowData.forEach((row, i) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    // let color=false;
    row.forEach((value, index) => {
       const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      //    if(value==="Average"){
      //      color=true;
      //    }

      // if ([1, 2].includes(index + 1) || color) {
      //   cell.style = { fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'd8ebed' } } };
      //   cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      // }
  
   
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}


//********* Rural Monthly Indices ************

export const generateRuralMonthlyIndicesReport = async ({ excelObjectData, fileName }) => {

  const workbook = new ExcelJS.Workbook();



  for (let i = 0; i < excelObjectData.length; i++) {

    const worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);

      worksheet.mergeCells(excelObjectData[i].firstRowMergeCells);
      const firstHeaderRow = worksheet.getRow(1);
      firstHeaderRow.getCell(1).value = excelObjectData[i].firstRowExportDate
      firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
      firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
      firstHeaderRow.height = 15;
      
      worksheet.mergeCells(excelObjectData[i].secondRowMergeCells);
      const secondHeaderRow = worksheet.getRow(2);
      secondHeaderRow.getCell(1).value = excelObjectData[i].secondRowText;
      secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true  };
      secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      secondHeaderRow.height = 20;
      secondHeaderRow.getCell(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

   
  if(excelObjectData[i].sheetName==='Page1'){

       worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
        const thirdHeaderRow = worksheet.getRow(3);
        thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText;
        thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12,bold: true };
        thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        thirdHeaderRow.height = 20;
        thirdHeaderRow.getCell(1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };


        //Fourth Row Design and  Merge cells A3:L3

        worksheet.mergeCells(excelObjectData[i].fourthRowMergeCells);
        const fourthHeaderRow = worksheet.getRow(4);
        fourthHeaderRow.getCell(1).value = excelObjectData[i].fourthRowText;
        fourthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true };
        fourthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        fourthHeaderRow.height = 20;
        fourthHeaderRow.getCell(1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };


        //Fifth Row Design and  Merge cells A3:L3

        worksheet.mergeCells(excelObjectData[i].fifthRowMergeCells);
        const fifthHeaderRow = worksheet.getRow(5);
        fifthHeaderRow.getCell(1).value = excelObjectData[i].fifthRowText;
        fifthHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true };
        fifthHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        fifthHeaderRow.height = 20;
        fifthHeaderRow.getCell(1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };



        if (excelObjectData[i].reportType === 'RegionWise') {
        const headerRow6 = worksheet.addRow([
          'अवधि','राज्य','क्षेत्र  Region','','','','Period'
        ]);
        headerRow6.height = 55;
        headerRow6.eachCell((cell, colNumber) => {
          cell.font = { bold: true, name: 'SansSerif', size: 12 };
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });

        
          worksheet.mergeCells('C6:F6');
        }

        const headerRow7 = worksheet.addRow(excelObjectData[i].headerHindiColumns);
        headerRow7.height = 55;
        headerRow7.eachCell((cell, colNumber) => {
          cell.font = { bold: true, name: 'SansSerif', size: 12 };
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
          cell.value = breakTitle(cell.value);
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },

          };
          const column = worksheet.getColumn(colNumber);
          column.width = 25;

        });


        if (excelObjectData[i].reportType === 'RegionWise') {
          worksheet.mergeCells('A6:A7');
          worksheet.mergeCells('B6:B7');
          worksheet.mergeCells('G6:G7');
        }

        const headerRow8 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
        headerRow8.height = 55;
        headerRow8.eachCell((cell, colNumber) => {
          cell.font = { bold: true, name: 'SansSerif', size: 12 };
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
          cell.value = breakTitle(cell.value);
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },

          };
          const column = worksheet.getColumn(colNumber);
          column.width = 25;

        });

      

        excelObjectData[i].excelRowData.forEach((row) => {  //Excel Data Loop
          const dataRow = worksheet.addRow(row);
          dataRow.height = 25;
          let isTotalRow = false;
          row.forEach((value, index) => {
            const cell = dataRow.getCell(index + 1);
            cell.font = { name: 'SansSerif', size: 10 };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            };
            if (value === 'TOTAL') {
              isTotalRow = true;
            }
            // Customize styling for the cells if needed
          });

        });

    }else{
          const imageId = workbook.addImage({
            // buffer: imageBuffer,
            base64: excelObjectData[i].base64String,
            extension: 'png', 
        });

        // Add image to worksheet
        worksheet.addImage(imageId, {
            tl: { col: 0, row: 4 },
            ext: { width: 1000, height: 400 }
        });
        

      }




  }





  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
 FileSaver.saveAs(blob, fileName);
};


//************ Misc Report **************

export const generateMiscReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:U1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif',size:10};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  
  //Second Row Design and  Merge cells A2:U2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif',size:15};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 40;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  const headerRow1 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow1.height = 55;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 10 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

  });

  worksheet.getColumn(1).width = 10; // Column 1
  worksheet.getColumn(2).width = 50; // Column 2
  for (let col = 3; col <= worksheet.columnCount; col++) { // Columns 3 and onwards
    worksheet.getColumn(col).width = 15;
  }

    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=25;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
    });


    
    // Adjust column widths to fit the content
    
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};



//******* Rural Ornaments Report*************

export const generateOrnamentReport = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true  };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 50;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };



  //Third Row Design and  Merge cells A3:L3

  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12,bold: true };
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  thirdHeaderRow.height = 30;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  const headerRow1 = worksheet.addRow(excelObjectData.headerHindiColumns);
  headerRow1.height = 40;
  headerRow1.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
  });

  

  const headerRow2 = worksheet.addRow(excelObjectData.headerHindiColumns2);
  headerRow2.height = 40;
  headerRow2.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
  });


  const headerRow3 = worksheet.addRow(excelObjectData.headerHindiColumns3);
  headerRow3.height = 30;
  headerRow3.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
  });
  worksheet.mergeCells('A4:B4')
  worksheet.mergeCells('C4:Q4')
  worksheet.mergeCells('A5:A6')
  worksheet.mergeCells('B5:B6')
  worksheet.mergeCells('C5:C6')

  const headerRow4 = worksheet.addRow(excelObjectData.headerHindiColumns4);
  headerRow4.height = 30;
  headerRow4.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };
  });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = null;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });

  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};


//*********** List Report Rural Wage ****************/

export const generateListReportRural = async (excelObjectData) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  // First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate;
  firstHeaderRow.getCell(1).font = { name: 'SansSerif', size: 10 };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
  firstHeaderRow.height = 15;
  firstHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Second Row Design and Merge cells A2:K2
  worksheet.mergeCells(excelObjectData.secondRowMergeCells);
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif', size: 12, bold: true };
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  secondHeaderRow.height = 50;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Create header row and apply conditional formatting for "women" report type
  const headerRow1 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow1.height = 30;
  headerRow1.eachCell((cell, colNumber) => {
    // Default font settings for header
    let fontSettings = { bold: true, name: 'SansSerif', size: 10 };

    // Check if the report type is "women" and if the column is C through I (columns 3 to 9)
    if (excelObjectData.reportType === 'women' && colNumber >= 3 && colNumber <= 9) {
      fontSettings.color = { argb: 'FF0000' };  // Red color
    }

    cell.font = fontSettings;
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.value = breakTitle(cell.value);
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    // Set column width
    const column = worksheet.getColumn(colNumber);
    column.width = 18;
  });

  excelObjectData.excelRowData.forEach((row) => {
    // Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 20;
    let isTotalRow = false;
    row.forEach((value, index) => {
      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if (value === 'TOTAL') {
        isTotalRow = true;
      }
      // Customize styling for the cells if needed
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);
};




//*******Index Report WPR Excel Sheet ****************
export const IndexReportWPRExcelSheet = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')
  //2
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells);
  let headerRow10 = worksheet.getRow(3);
  headerRow10.getCell(1).value = excelObjectData.thirdRowText;
  headerRow10 = excelColumnDesign(headerRow10, true, 14, 'center')


  //3
  let headerRow12 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow12.height = 30;
  headerRow12.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: 'SansSerif', size: 12 };
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },

    };

    const column = worksheet.getColumn(colNumber);
    column.width = '30';
  });



  excelObjectData.excelRowData.forEach((row, i) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    let bold=false;;
    row.forEach((value, index) => {
       const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      if(excelObjectData.boldColumn.includes(value)){
        bold=true
      }

      if(bold){
        dataRow.getCell(index).font ={bold:true }
        cell.font = {bold:true };
      }

     

    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}





//Monthly Whole Sale Index Item Wise Report *********************
export const MonthlyWholeSaleIndexItemwiseExcelData = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  let worksheet = workbook.addWorksheet(excelObjectData.sheetName);
  worksheet = getExcelTwoHeader(worksheet, excelObjectData, 'right', 'center')


  //excel English Column
  const headerRow4 = worksheet.addRow(excelObjectData.headerEnglishColumns);
  headerRow4.height = 50;
  headerRow4.eachCell((cell, colNumber) => {
  cell.font = { bold: true, name: 'SansSerif', size: 12 };
  cell.fill =  { type: 'pattern', pattern: 'solid', fgColor: { argb: 'C6DDF0' }};
  cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  cell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },

  };
    const column = worksheet.getColumn(colNumber);
    column.width = 17;
 });


  excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
    const dataRow = worksheet.addRow(row);
    dataRow.height = 27;
    let boldText=false;
    row.forEach((value, index) => {

      const cell = dataRow.getCell(index + 1);
      cell.font = { name: 'SansSerif', size: 10 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };

     
      if(excelObjectData.boldColumn.includes(value)){
        boldText=true
      }

      if(boldText){
           dataRow.getCell(index).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '76AEDF' }
        };
        dataRow.getCell(index).font ={bold:true}
        dataRow.getCell(index+1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '76AEDF' }
        };
        dataRow.getCell(index+1).font ={bold:true}
      }else{
        dataRow.getCell(index + 1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'C6DDF0' }
        };
      }
     


    });

  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  const fileName = `${excelObjectData.fileName}.${excelObjectData.fileType}`;
  FileSaver.saveAs(blob, fileName);


}





// Whole sale Price Comparision Report ***************
export const WholesalePriceComparisionReportSheet = async ({ excelObjectData, fileName }) => {

  const workbook = new ExcelJS.Workbook();

  for (let i = 0; i < excelObjectData.length; i++) {
    let worksheet = workbook.addWorksheet(excelObjectData[i].sheetName);
    worksheet = getExcelTwoHeader(worksheet, excelObjectData[i], 'right', 'center')

    worksheet.mergeCells(excelObjectData[i].thirdRowMergeCells);
    const thirdHeaderRow = worksheet.getRow(3);
    thirdHeaderRow.getCell(1).value = excelObjectData[i].thirdRowText
    thirdHeaderRow.getCell(1).font = { bold: true, name: 'SansSerif', size: 14 };
    thirdHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    thirdHeaderRow.height = 25;
    thirdHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    if(excelObjectData[i].sheetType==='sheet2'){

      const headerRow4 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
      headerRow4.height = 25;
      headerRow4.eachCell((cell, colNumber) => {
        cell.font = { bold: true, name: 'SansSerif', size: 12 };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.value = breakTitle(cell.value);
      
        const column = worksheet.getColumn(colNumber);
       column.width = 30;
     });


    const imageId = workbook.addImage({
        // buffer: imageBuffer,
        base64: excelObjectData[i].base64String,
        extension: 'png', 
    });

    // Add image to worksheet
    worksheet.addImage(imageId, {
        tl: { col: 0, row: 4 },
        ext: { width: 1000, height: 400 }
    });
   
    worksheet.mergeCells('A7:A20')
    worksheet.mergeCells('B7:B20')
    worksheet.mergeCells('C7:C20')
    worksheet.mergeCells('D7:D20')
    worksheet.mergeCells('E7:E20')
    // worksheet.mergeCells('A11:F11')
    }else{


             //excel English Column *****************
    const headerRow4 = worksheet.addRow(excelObjectData[i].headerEnglishColumns);
    headerRow4.height = 40;
    headerRow4.eachCell((cell, colNumber) => {
      cell.font = { bold: true, name: 'SansSerif', size: 12 };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },

      };
      const column = worksheet.getColumn(colNumber);

      if (colNumber === 1) {
        column.width = 28;
      } else {
        column.width = 22;
      }


    });


    //Excel Data Loop *****************
    (excelObjectData[i].excelRowData || []).forEach((row) => {
      const dataRow = worksheet.addRow(row);
      dataRow.height = 20;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        const isPctColumn = index === 4 || index === 5; // % Variation columns
        let fontColor;
        if (isPctColumn) {
          const num = parseFloat(value);
          if (!Number.isFinite(num) || num === 0) {
            fontColor = 'FF0000FF'; // blue for 0
          } else if (num < 0) {
            fontColor = 'FFFF0000'; // red for negative
          } else {
            fontColor = 'FF008000'; // green for positive
          }
        }
        cell.font = {
          name: 'SansSerif',
          size: 10,
          bold: index === 0 || isPctColumn,
          ...(fontColor ? { color: { argb: fontColor } } : {}),
        };
        cell.alignment = { horizontal: index === 0 ? 'left' : 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
     
     });

    });



    }

 



  } // End For Loop ************


  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, fileName);

};